
import React, { Component } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { translate } from 'react-i18next';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import { usersVerifyPass } from '../../../libs/services';
var Config = require('../../../config');

class ModalConfirm extends Component{
	constructor(props) {
		super(props);
		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.traceability = this.traceability.bind(this);
		this.handleChange = this.handleChange.bind(this);
        this.validUser = this.validUser.bind(this);
		this.getReason=this.getReason.bind(this)
		this.state = {
		    show: false,
		    reval_user:sessionStorage.getItem('user_name'),
		    reval_pass:"",
			list_reason:[],
			reason:""
		};
	}

	componentDidMount() {
		this.props.onRef(this);
		this.getReason()
		
		//console.log(this.props)
	}

	componentWillUnmount(){
		this.props.onRef(null);
	}

	handleClose() {
		this.setState({ show: false, reval_pass:"",reason:""});
	}

	handleShow() {
		this.setState({ show: true});
	}

	handleChange(e){
	    this.setState({
	      [e.target.name]: e.target.value
	    });
	}

	isValidForm() {
	    const inputs = document.querySelectorAll('input, select');
	    let isFormValid = true;
	    inputs.forEach(input => {
	    	if(input.required){
		      	const isInputValid = this.showInputError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		  	}
	    });	  
	    
	    return isFormValid;
	}

	showInputError(refName) {
		const control = document.getElementById(refName);
		
		if(control.value === ""){
			if(control !== null){
	            control.classList.add('error');
	        }
			return false;
		}else{
			if(control.className.includes('error')){
				control.classList.remove('error');
			}
			return true;
		}
	}

	getReason(){
		//console.log("entor")
			//this.props.waiting.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'lookups?type=reasons_reprinting_labels&option=actives&order=true', {
				method: 'GET',
				headers: new Headers({
					'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			}).then(res => {
				//this.props.waiting.handleClose();
				if(res.ok){
					return res.json();
				}else{
					res.text().then((msg)=>{
						swal('Error', msg, 'error');
					});
				}
			}).then(response => {
				if(response !== undefined){
					this.setState({
						list_reason: response
					});
					//console.log(response)
				}
			});
		}
    async validUser(){
        if(this.isValidForm()){
			var password = btoa(this.state.reval_pass);
			password = password.split("").reverse().join("");

			var obj = {
				username:this.state.reval_user,
				password:password
			};
		//console.log(this.state.reason)
			var response = await usersVerifyPass(obj, this.props.waiting);
			if(response !== undefined){
				 this.props.onPrint(response,this.state.reason); //this.traceability();
			}
			
		}else{
			swal('Error', 'Campos incompletos', 'error');
		}	
    }

	
	async traceability(){
		var obj = {
			action: 'PROCESSED',
			description:'PROCESADO REIMPRESIÓN POR'+this.setState.reason+' '
		}
		fetch(Config.default.apiGateway.URL+'traceabilities/reprint',{
			method:'POST',
			body:JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then((res)=>{
			if(res.ok){
				return 'correcto';
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({ show: false});
			}
		})
	}

	render(){
		const { t } = this.props;
		return(
			<Modal show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Reimpresión de Etiqueta</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row" style={{textAlign:"center"}}>
		        		<div className="col-xs-12 col-sm-10 col-md-offset-1">
		        			<div className="col-xs-12 form-group">
                                <div className='col-xs-12'>
                                    <h3>¿ESTÁ SEGURO REIMPRIMIR LA ETIQUETA?</h3>
                                </div>

								<div className="form-group col-xs-12">
					        	<div className="col-xs-12 col-sm-4">
					        		<span className="span-min">
					        			Motivo
					        		</span>
				        		</div>
				        		<div className="col-xs-12 col-sm-8">
						        	<select className="form-control" name="reason" id="reason" 
										value={this.state.reason} onChange={this.handleChange}
										 required>
										<option value="">Seleccione...</option>
										{this.state.list_reason.map((g, i)=>{
											return <option key={i} value={g.name}>
												{g.name}
											</option>
										})}
									</select>
					        	</div>
				        	</div>
			        			<div className="col-xs-12 col-sm-4">
					        		<span className="span-min">
					        			Usuario
					        		</span>
				        		</div>
				        		<div className="col-xs-12 col-sm-8">
						        	<input className="col-xs-12 form-control"
						        		name="reval_user" id="reval_user"						        		
						        		value={this.state.reval_user}
						        		onChange={this.handleChange}
                                        autoComplete="off"
                                        disabled
						        		required/>
					        	</div>
				        	</div>

				        	<div className="form-group col-xs-12">
					        	<div className="col-xs-12 col-sm-4">
					        		<span className="span-min">
					        			Contraseña
					        		</span>
				        		</div>
				        		<div className="col-xs-12 col-sm-8">
						        	<input className="col-xs-12 form-control"
						        		name="reval_pass" id="reval_pass"
						        		type="password"
						        		value={this.state.reval_pass}
						        		onChange={this.handleChange}
                                        autoComplete="off"
						        		required/>
					        	</div>
				        	</div>
							
			        	</div>
			        	
				    </div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={"Si, Imprimir"} onClick={this.validUser}/>
		        	<FlatButton primary={true} label={'No, '+t('content.generics.buttons.reset')} onClick={this.handleClose} />
		        </Modal.Footer>
	      	</Modal>
		);
	}
}

export default translate('translations')(ModalConfirm) 